module.exports = __webpack_public_path__ + "static/monday1-442971eb999263764513256743892278.png";